export default __webpack_public_path__ + "static/media/noImg.52fd88d1.jpg";